// Taxas de câmbio fixas AOA → moeda estrangeira.
// 1 unidade da moeda X = N AOA. Mesmas taxas usadas na integração Dodo.
export const EXCHANGE_RATES_AOA: Record<string, number> = {
  AOA: 1,
  USD: 1100,
  EUR: 1200,
  BRL: 220,
  ZAR: 60,
};

export type SupportedCurrency = "AOA" | "USD" | "EUR" | "BRL" | "ZAR";

export function isSupportedCurrency(code: string | null | undefined): code is SupportedCurrency {
  return !!code && code in EXCHANGE_RATES_AOA;
}
